const $ = jQuery;

const t = (key, fallback = '') => (window.SPRAGA_I18N && SPRAGA_I18N[key]) || fallback || key;

function applyGlobalValidationMessages() {
    if (!$.validator || !$.validator.messages) return false;

    const fieldMessages = {
        required: t("required_validation", "This field is required."),
        remote: t("remote_validation", "Please fix this field."),

        email: t("email_validation", "Please enter a valid email address."),
        url: t("url_validation", "Please enter a valid URL."),
        date: t("date_validation", "Please enter a valid date."),
        dateISO: t("dateISO_validation", "Please enter a valid date (ISO)."),
        number: t("number_validation", "Please enter a valid number."),
        digits: t("digits_validation", "Please enter only digits."),
        creditcard: t("creditcard_validation", "Please enter a valid credit card number."),

        minlength: t("minlength_validation", "Please enter at least {0} characters."),
        maxlength: t("maxlength_validation", "Please enter no more than {0} characters."),
        rangelength: t("rangelength_validation", "Please enter a value between {0} and {1} characters long."),

        min: t("min_validation", "Please enter a value greater than or equal to {0}."),
        max: t("max_validation", "Please enter a value less than or equal to {0}."),
        range: t("range_validation", "Please enter a value between {0} and {1}."),

        equalTo: t("equalTo_validation", "Please enter the same value again."),
        accept: t("accept_validation", "Please enter a value with a valid extension."),
        extension: t("extension_validation", "Please enter a value with a valid extension."),
        pattern: t("pattern_validation", "Please match the requested format."),
    };

    $.extend($.validator.messages, fieldMessages);

    $.validator.defaults = $.validator.defaults || {};
    $.validator.defaults.messages = $.validator.defaults.messages || {};
    $.extend($.validator.defaults.messages, fieldMessages);

    return true;
}

(function waitForValidator() {
    if (applyGlobalValidationMessages()) return;
    setTimeout(waitForValidator, 50);
})();
